import React from 'react'
import { Upload, Icon, Tooltip, message } from "antd";
import PropTypes from "prop-types";
import { config, uploadEnclosure, postFrom } from '../../axios';
import ImageView from '../ImageView';
import './index.less'

const fileMap = [

    { attachType: 1, attachName: '附件', files: [] },
    { attachType: 2, attachName: '身份证头像照', files: [] },
    { attachType: 3, attachName: '身份证国徽照', files: [] },
    { attachType: 4, attachName: '人脸照', files: [] },
    { attachType: 5, attachName: '纸质合同附件', files: [] },
    { attachType: 6, attachName: '电子合同', files: [] },
    { attachType: 7, attachName: '电子合同附页', files: [] },

    { attachType: 8, attachName: '原租赁合同、产权证明', files: [] },
    { attachType: 9, attachName: '入围房源清单、租客清单', files: [] },
    { attachType: 10, attachName: '营业执照', files: [] },
    { attachType: 11, attachName: '法人身份信息', files: [] },
    { attachType: 12, attachName: '征信及资产资料', files: [] },
    { attachType: 13, attachName: '白名单报告及担保函', files: [] },
    { attachType: 17, attachName: '转账附件', files: [] },
    { attachType: 18, attachName: '银行回执信息', files: [] },
    { attachType: 14, attachName: '其它', files: [] },
]

class FileUpload extends React.Component{
    state = {
        fileMap:[]
    }
    componentDidMount() {
        this.setState(state => {
            state.fileMap = fileMap.filter(e => this.props.fileTypeList.includes(e.attachType))
            return state
        })
    }
    handleUpload(type, name, fileData) { // --- 上传附件
        
        this.setState(state => {
            state.fileMap.forEach(e => {
                if(e.attachType === type) {
                    e.files.push(fileData)
                }
            })
            
            return state
        })
        
    }
    parseAttachToIds = () => { // --- 附件 --> 吧state 中附件 转为 Ids
        let ids = []

        this.state.fileMap.forEach((e) => {
            e.files.forEach(ee => {
                ids.push(ee.attach_id) 
            })
        })
        return ids
    }
    parseAttachToFormat = (attachList) => { // --- 附件 --> 格式化 返回值
        this.setState(state => {
            state.fileMap.map(e => {
                const current = attachList
                    .filter(ee => ee.attachType === e.attachType)
                    .map(ee => ({ attach_id: ee.id, attach_name: ee.fileName, attach_url: ee.fileUrl}))

                e.files = current
                return e
            })
            return state
        })
    }
    setFileToState = (attachList)  => {
        this.parseAttachToFormat(attachList)
    }
    postFileList = () => {
        const params = {
            tableName: this.props.tableName,
            rowId: this.props.rowId
        }
        
        postFrom({ url: config.API_attach_list, data: params }).then(res => {
            this.setFileToState(res.records || [])
        }).catch(err => {
            message.error(err.message || '获取附件失败');
            this.setState({ loading: false });
        });
    }
    handleFileDelete = (index, childIndex) => { // --- 附件 --> 根据fileMap 的索引 删除
        this.setState(state => {
            state.fileMap[index].files.splice(childIndex,1)
            return state
        })
    }
    createFileView = (file, index, childIndex) => { // --- 附件 --> 根据src 返回 图片还是其它
        if(!file) {
            return 
        }
        
        const imgfilter = ['.png', '.jpg', '.gif', '.jpeg']
        let isImg = false
        imgfilter.forEach((e) => {
            if(file.attach_url.indexOf(e) > -1){
                isImg = true
            }
        })
        if(isImg) {
            return <ImageView showPreview showDelete onDelete={this.handleFileDelete.bind(this,index,childIndex)} src={file.attach_url} mode="aspectFit" style={{width:120, height:120, border: '1px solid #eee'}} />
        }
        return (
            <div className="upload-box file" style={{margin:0}}>
                <Icon type="paper-clip" />
                <div className="mask">
                    <a href={file.attach_url} target="_blank">
                        <Icon type="eye" />
                    </a>
                    <Icon type="delete" onClick={this.handleFileDelete.bind(this,index,childIndex)} />
                </div>
            </div>
        )
    }

    render(){
        const uploadConfig = (e) => uploadEnclosure({
            accept: '*',
            tableName: this.props.tableName,
            success: this.handleUpload.bind(this, e.attachType), 
            attachType: e.attachType, 
            rowId: this.props.rowId || 0 
        })
        return (
            <div>
                {
                    this.state.fileMap.map((e,i) => (
                        <div className="file-item" key={'file-' + i}>
                            {this.props.hideLabel || <div className="label">{e.attachName}</div>}
                            
                            <div className={this.props.isValueStyle?"newValue value":"value"} >
                                <Upload {...uploadConfig(e)}>
                                    <div className="upload-box">
                                        <Icon type="plus" />
                                    </div>
                                </Upload>  
                                {e.files.map((ee,ii) => {
                                    return (
                                        <div className="img-wrap" key={'file-' + i + '-' + ii} >
                                            {this.createFileView(ee, i, ii)}
                                            <Tooltip title={ee.attach_name} >
                                                <div className="filename">{ee.attach_name}</div>
                                            </Tooltip>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}
FileUpload.propTypes = {
    // attachList: PropTypes.array,
    fileTypeList: PropTypes.array.isRequired,
    tableName: PropTypes.string.isRequired,
    rowId: PropTypes.number.isRequired,
    hideLabel: PropTypes.bool,
    isValueStyle: PropTypes.isValueStyle
};
export default FileUpload


// WEBPACK FOOTER //
// ./src/components/FileUpload/index.js